import React from 'react';
import useError from '../hooks/useCaseStatus';
import { EditableField } from './EditableField';
import { INPUTS } from './types';
import { useSelector } from 'react-redux';
import { getIsCaseDirty } from '../store/subPages/selectors';
import useCaseIsReadOnly from '../../../helpers/hooks/useCaseIsReadOnly/useCaseIsReadOnly';

const CaseStatusChangeField = ({ field, caseStatuses, onChange, searchable, withDefaultOption }: any) => {
  const status = useError();
  const isDirty = useSelector(getIsCaseDirty);
  const isCaseReadOnly = useCaseIsReadOnly();

  return (
    <EditableField
      fieldType={INPUTS.SELECT}
      field={field}
      options={caseStatuses}
      onFieldChange={onChange}
      value={status}
      disabled={isDirty || isCaseReadOnly}
      searchable={searchable}
      withDefaultOption={withDefaultOption}
      extraContent={
        isDirty
          ? [
              {
                position: 'bottom',
                variant: 'warning',
                content: 'Please save a case before changing a status',
              },
            ]
          : []
      }
    />
  );
};

export default CaseStatusChangeField;
